import { Controller } from "@hotwired/stimulus";

class ListFilters extends Controller<HTMLDivElement> {
  static targets = [
    "searchBox",
    "filters",
    "enabledFilters",
    "searchButton",
    "closeSearchButton"
  ];

  watchUrlInterval: NodeJS.Timeout;

  declare readonly searchBoxTarget: HTMLDivElement;
  declare readonly hasSearchBoxTarget: boolean;

  declare readonly filtersTarget: HTMLDivElement;
  declare readonly hasFiltersTarget: boolean;

  declare readonly enabledFiltersTarget: HTMLDivElement;
  declare readonly hasEnabledFiltersTarget: boolean;

  declare readonly searchButtonTarget: HTMLLinkElement;
  declare readonly hasSearchButtonTarget: boolean;

  declare readonly closeSearchButtonTarget: HTMLLinkElement;
  declare readonly hasCloseSearchButtonTarget: boolean;

  showSearchBox(e: MouseEvent) {
    e.preventDefault();
    this.filtersTarget.classList.add("hidden");
    this.enabledFiltersTarget.classList.add("hidden");
    this.searchButtonTarget.classList.add("hidden");
    this.closeSearchButtonTarget.classList.remove("hidden");
    this.searchBoxTarget.classList.remove("hidden");
  }

  showFilters(e: MouseEvent) {
    e.preventDefault();
    this.filtersTarget.classList.remove("hidden");
    this.enabledFiltersTarget.classList.remove("hidden");
    this.searchButtonTarget.classList.remove("hidden");
    this.closeSearchButtonTarget.classList.add("hidden");
    this.searchBoxTarget.classList.add("hidden");
  }

  clearSearch(e: MouseEvent) {
    this.showFilters(e);
    const searchField =
      this.searchBoxTarget.querySelector<HTMLInputElement>(
        "input[type=search]"
      );
    if (searchField) {
      searchField.value = "";
      searchField.form?.requestSubmit();
    }
  }
}

export default ListFilters;
